import * as React from "react";
import { Line as KonvaLine } from "react-konva";
import { Seat, Line } from "../types";

interface Props {
  data: Line;
  yMax: number;
  xMax: number;
  yMin: number;
  xMin: number;
  canvasWidth: number;
  canvasHeight: number;
  marginTopBottom: number;
  marginLeftRight: number;
}

const LineComponent: React.FC<Props> = ({
  data,
  xMax,
  yMax,
  xMin,
  yMin,
  canvasWidth,
  canvasHeight,
  marginTopBottom,
  marginLeftRight,
}) => {
  const ratioY = canvasWidth / (yMax - yMin);
  const ratioX = canvasHeight / (xMax - xMin);

  const seatWidth = 1.85 * ratioX;

  const X1 =
    data.X1 * ratioX - xMin * ratioX + (canvasWidth - (xMax - xMin) * ratioX);
  const X2 =
    data.X2 * ratioX - xMin * ratioX + (canvasWidth - (xMax - xMin) * ratioX);
  const Y1 =
    data.Y1 * ratioY - yMin * ratioY + (canvasHeight - (yMax - yMin) * ratioY);
  const Y2 =
    data.Y2 * ratioY - yMin * ratioY + (canvasHeight - (yMax - yMin) * ratioY);

  return (
    <KonvaLine points={[X1, Y1, X2, Y2]} stroke={"#92723B"} strokeWidth={1} />
  );
};

export default LineComponent;
